import { type AnchorHTMLAttributes } from "react";

// Render markdown links with safe rel attributes (prevents reverse-tabnabbing) for a11y.
const MarkdownLink = ({ href, target, children }: AnchorHTMLAttributes<HTMLAnchorElement>) => (
  <a href={href} target={target} rel="noopener noreferrer">
    {children}
  </a>
);

export default MarkdownLink;
